import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  IconButton,
  Badge,
  useColorModeValue,
  Portal,
} from '@chakra-ui/react';
import { BellIcon } from '@chakra-ui/icons';
import { useNotifications } from '../../hooks';
import NotificationPanel from './NotificationPanel';

const NotificationBell: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { notifications, loading, unreadCount, handleNotificationClick, refetch } = useNotifications();

  // Filter to show only unread notifications in the panel (check both fields)
  const unreadNotifications = notifications.filter(n => !n.isRead && !n.read_at);
  
  console.log('🔔 [NotificationBell] Total notifications:', notifications.length);
  console.log('🔔 [NotificationBell] Unread notifications:', unreadNotifications.length);
  console.log('🔔 [NotificationBell] Unread count from hook:', unreadCount);

  const handleBellClick = () => {
    // Navigate to notifications page (keeps history)
    navigate('/notifications');
    // Also refresh notifications
    refetch();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleNotificationItemClick = async (notification: any) => {
    console.log('📱 NotificationBell: Handling click, will close panel after navigation');
    
    try {
      // Handle navigation and marking as read first
      await handleNotificationClick(notification);
      
      // Close panel after navigation completes
      console.log('📱 NotificationBell: Navigation complete, closing panel');
      setIsOpen(false);
    } catch (error) {
      console.error('📱 NotificationBell: Error handling notification click:', error);
      // Close panel even if there's an error
      setIsOpen(false);
    }
  };

  // (panel open via route now) no global open listener required

  return (
    <>
      <Box position="relative">
        <IconButton
          aria-label="Notifications"
          icon={<BellIcon />}
          variant="ghost"
          size="lg"
          onClick={handleBellClick}
          color={useColorModeValue('gray.600', 'gray.300')}
          _hover={{
            bg: useColorModeValue('gray.100', 'gray.700'),
          }}
        />
        
        {unreadCount > 0 && (
          <Box
            position="absolute"
            top="2px"
            right="2px"
            zIndex={2}
            onClick={(e) => { e.stopPropagation(); handleBellClick(); }}
            cursor="pointer"
          >
            <Badge
              colorScheme="red"
              variant="solid"
              borderRadius="full"
              fontSize="xs"
              minW="22px"
              h="22px"
              px="6px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              animation="pulse 2s infinite"
              boxShadow="0 2px 4px rgba(0,0,0,0.2)"
            >
              {unreadCount > 99 ? '99+' : unreadCount}
            </Badge>
          </Box>
        )}
      </Box>

      {/* Use Portal to render panel at body level for proper z-index */}
      <Portal>
        <NotificationPanel
          isOpen={isOpen}
          onClose={handleClose}
          notifications={unreadNotifications}
          loading={loading}
          onNotificationClick={handleNotificationItemClick}
        />
      </Portal>
    </>
  );
};

export default NotificationBell;
